import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import { fetchADObjectDomains } from '@/sections/insights/queryBuilder/entities/utils/fieldValues';
import type { QueryFilter } from '@/types';

/**
 * AD Object Domain field definition
 * Dynamically fetches available domains from statistics
 */
export const ADObjectDomain: SimpleFilterDefinition = {
  apiField: 'domain',
  uiField: 'Domain',
  inputType: 'dropdown',
  getAvailableValues: fetchADObjectDomains, // Lazy-loaded on dropdown open
  operators: ['is', 'is not', 'is any of'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'Domain',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: queryFilter.value as string | string[],
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'domain',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: simpleFilter.value,
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
